/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getOrderDetailsAdditionalInformationAsync } from './DataActionExtension.g';
import { IGetOrderDetailsAdditionalInformationResponse } from './DataServiceEntities.g';

/**
 * GetOrderDetailsAdditionalInfo Input Action
 */
export class GetOrderDetailsAdditionalInfoInput implements Msdyn365.IActionInput {
    public salesId: string;
    constructor(salesId: string) {
        this.salesId = salesId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ORDERDETAILSID:${this.salesId}`;
    public getCacheObjectType = () => 'ORDERDETAILSINFO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// // TODO: Create a data model here or import one to capture the response of the action
// export interface IGetOrderDetailsAdditionalInfoData {
//     containerDetails: IContainerDetailsEntity;
//     errorMessage: string;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createOrderDetailsAddInfoInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const salesId = args.requestContext.url.requestUrl.searchParams.get('salesId');
    return new GetOrderDetailsAdditionalInfoInput(salesId || '');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
    input: GetOrderDetailsAdditionalInfoInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetOrderDetailsAdditionalInformationResponse> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    const response = await getOrderDetailsAdditionalInformationAsync({ callerContext: ctx }, input.salesId);
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetOrderDetailsAdditionalInformationResponse>>action,
    // TODO: Give your data action a unique id
    id: 'GetOrderDetailsAdditionalInfo',
    input: createOrderDetailsAddInfoInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
